import React from "react";
import {
  Datagrid,
  Filter,
  List,
  Pagination,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  TextField,
  TextInput,
} from "react-admin";

const ArticleDppFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search by name" source="name" alwaysOn />
    <TextInput label="Reference" source="reference" />
    <TextInput label="Collection" source="collection" />
    <ReferenceInput
      label="Project"
      source="projectId"
      reference="projects"
      filterToQuery={(q) => ({ name: q })}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

const ArticleDppPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

const ArticleDppList = (props) => (
  <List
    {...props}
    filters={<ArticleDppFilter />}
    pagination={<ArticleDppPagination />}
    bulkActionButtons={false}
    hasCreate={false}
    exporter={false}
  >
    <Datagrid rowClick="show">
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="reference" />
      <TextField source="collection" />
      <ReferenceField label="Project" source="projectId" reference="projects" link={false}>
        <TextField source="name" />
      </ReferenceField>
    </Datagrid>
  </List>
);

export default ArticleDppList;
